import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { IPosterOrder, IPosterOrderItem } from '../../../../../../../common/common-interfaces/poster-order';
import moment from 'moment';
import { Utility } from '../../../services/utility';
import { IStoreSettings } from '../../../../../../../common/common-interfaces/store-settings';

@Component({
    selector: 'all-poster-orders',
    templateUrl: './all-poster-orders.component.html',
    styleUrls: ['./all-poster-orders.component.scss'],
    standalone: false
})
export class AllPosterOrdersComponent {
  orders: (IPosterOrder & any)[] = [];
  stores: IStoreSettings[];
  storesById: { [id: string]: IStoreSettings } = {};
  statuses: string[] = ['PENDING', 'READY', 'QUEUED_FOR_PRINT', 'PRINTED', 'SHIPPED', 'DELIVERED', 'CANCELLED', 'ERROR'];
  periodStart: Date;
  periodEnd: Date;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {

  }

  async ngOnInit() {
    this.periodStart = moment().subtract(1, 'week').toDate();
    this.periodEnd = moment().toDate();

    this.stores = await this.api.admin().get<any>(`/stores`);

    for (let store of this.stores) {
      this.storesById[store._id] = store;
    }


    await this.fetchOrders();
  }

  getOrderFulfillmentPartners(order: IPosterOrder) {
    let result = {};
    for (let item of order.items) {
      result[item.fulfillmentPartner] = true;
    }
    return Object.keys(result);
  }

  async fetchOrders() {
    delete this.orders;
    this.orders = await this.api.admin().get<any>(`/poster-orders?statuses=${this.statuses.join(',')}&startDate=${moment(this.periodStart).toISOString()}&endDate=${moment(this.periodEnd).toISOString()}`);

    for (let order of this.orders) {
      for (let item of order.items) {
        if (item.status == 'UNKNOWN') {
          (item as any).itemInfo = {
            isStockItem: false,
            posterType: 'POSTER',
            sku: ''
          };
        }
      }
    }

  }

  getAdjustmentDiff(order: IPosterOrder) {
    if (order.cost && order.costBeforeAdjustment) {
      let diff = order.cost.total - order.costBeforeAdjustment.total;
      if (diff < 1 && diff > -1) {
        return 0;
      }
      return diff;
    }

    return 0;
  }

  async search() {


  }



}


